import { useMemo, type JSX } from 'react';
import { Box, List, useMediaQuery } from '@react/chakra';

import { Item } from './Item';
import { Popup } from './Popup';
import { buildContentTree } from './utils';

import type { IContentTreeProps, ITableOfContentsProps } from './interface';

export function TableOfContents({
  content,
}: ITableOfContentsProps): JSX.Element | null {
  const [supportTableOfContentsLeftSide] = useMediaQuery([
    '(min-width: 1580px)',
  ]);

  const headerTree = useMemo<IContentTreeProps[]>(() => {
    return buildContentTree(content.split('\n') || []);
  }, [content]);

  if (!headerTree.length) {
    return null;
  }

  if (!supportTableOfContentsLeftSide) {
    return <Popup data={headerTree} />;
  }

  return (
    <Box pos='absolute' bottom={0} top={0} w='250px' left='-280px'>
      <Box w='100%' h='100%' pos='relative'>
        <Box top='30%' pos='sticky' color='white'>
          <List.Root className='toc'>
            {headerTree.map((header) => {
              const { level, line, text } = header;

              return <Item key={`${level}-${line}-${text}`} data={header} />;
            })}
          </List.Root>
        </Box>
      </Box>
    </Box>
  );
}
